export enum OrganizationRole {
  admin = 'ADMIN',
  viewer = 'VIEWER',
  editor = 'EDITOR',
}
